import { render, staticRenderFns } from "./VirtualAccountPage.vue?vue&type=template&id=2874e8cb&scoped=true"
import script from "./VirtualAccountPage.vue?vue&type=script&lang=js"
export * from "./VirtualAccountPage.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccountPage.vue?vue&type=style&index=0&id=2874e8cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874e8cb",
  null
  
)

export default component.exports